// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"3613":"71b2dc5f","7751":"71b2dc5f"}[chunkId] + ".chunk.css";
};